const SERVICE_TIERS = Object.freeze({
    'ANTE-ERP': ['FREE', 'BASIC', 'PLUS', 'PRO', 'MAX'],
    'ANTE-MANUFACTURING': ['LIGHT', 'STANDARD', 'ADVANCED']
});

function servicesOf(session) {
    let snapshot = session && session.service_entitlements;
    if (typeof snapshot === 'string') {
        try { snapshot = JSON.parse(snapshot); } catch (e) { snapshot = null; }
    }
    return snapshot && snapshot.services && typeof snapshot.services === 'object'
        ? snapshot.services
        : {};
}

// Các header này chỉ là projection phục vụ nginx routing, không phải entitlement.
export function resolveServicePackage(info, serviceType) {
    const session = info && typeof info === 'object' ? info : {};
    const normalizedServiceType = String(serviceType || '').toUpperCase();
    const entitlement = servicesOf(session)[normalizedServiceType];
    const sessionTier = normalizedServiceType === 'ANTE-ERP' ? session.erp_service_tier : null;
    const tier = String(
        sessionTier ||
        (entitlement && (entitlement.tier || entitlement.service_tier || entitlement.service_code)) ||
        ''
    ).toUpperCase();
    const allowedTiers = SERVICE_TIERS[normalizedServiceType] || [];
    return allowedTiers.includes(tier) ? tier : 'NONE';
}

export function resolveERPServicePackage(info) {
    return resolveServicePackage(info, 'ANTE-ERP');
}

export function resolveManufacturingServicePackage(info) {
    return resolveServicePackage(info, 'ANTE-MANUFACTURING');
}

export function resolveServiceRoutingHeaders(info) {
    const erpTier = resolveERPServicePackage(info);
    const manufacturingTier = resolveManufacturingServicePackage(info);
    const language = resolveBusinessLanguage(info);
    return {
        // Alias chuyển tiếp; sẽ bỏ sau khi nginx/client đã chuyển hoàn toàn.
        ...(erpTier === 'NONE' ? {} : { 'Service-Package': erpTier, 'ERP-Service-Package': erpTier }),
        ...(manufacturingTier === 'NONE' ? {} : { 'Manufacturing-Service-Package': manufacturingTier }),
        // Ngôn ngữ business để BE dịch lỗi trả về cả khi chưa có session (đăng nhập, quá tải, gói tin lỗi).
        ...(language ? { 'Business-Language': language } : {})
    };
}

// Sys_BaseLanguage của business trong session-info đã lưu khi đăng nhập; chưa đăng nhập thì rỗng, BE trả tiếng Anh.
export function resolveBusinessLanguage(info) {
    const raw = info && info.bus_settings && info.bus_settings.Sys_BaseLanguage;
    const value = raw ? String(raw).trim() : '';
    return value && value !== 'null' && value !== 'undefined' && /^[A-Za-z]{2,3}(-[A-Za-z0-9]{2,8})?$/.test(value) ? value : '';
}

export function resolveServiceRoutingQuery(info) {
    const erpTier = resolveERPServicePackage(info);
    const manufacturingTier = resolveManufacturingServicePackage(info);
    return {
        ...(erpTier === 'NONE' ? {} : { ServicePackage: erpTier, ERPServicePackage: erpTier }),
        ...(manufacturingTier === 'NONE' ? {} : { ManufacturingServicePackage: manufacturingTier })
    };
}

export function resolveRoutingServicePackage(info) {
    return resolveERPServicePackage(info);
}

export default resolveRoutingServicePackage;
